module.exports = __webpack_public_path__ + "static/media/Brands_5.e7610f28.png";